import React from 'react';

export default function template(context) {
    const calc = context.calc,
        model = calc.state.model,
        options = model.getTerms().map((term, index) => (<option key={index} value={index}>{term}</option>));

    return (
        <React.Fragment>
            <div className="calculator-controllers">
                <div className="controller-block">
                    <div className="calc-block-title">
                        {calc.l10n('CALCULATOR_CREDIT_SUM')}
                    </div>

                    <div className="calculator-slider-wrapper">
                        <div className="calculator-slider-value">
                            {model.getCreditSum().toLocaleString()} {calc.l10n('CALCULATOR_UAH')}
                        </div>

                        <div className="calculator-slider">
                            <input type="range"
                                name="creditSum"
                                className="calculator-sum-slide"
                                onChange={calc.handleChange}
                                value={model.getCreditSum()}
                                min={model.getMinSumEdge()}
                                max={model.getMaxSumEdge()}
                                step={model.getSumStep()}
                            />
                        </div>
                    </div>
                </div>
                <div className="controller-block">
                    <div className="calc-block-title">
                        {calc.l10n('CALCULATOR_CREDIT_FORM')}
                    </div>
                    <div className="calculator-slider-wrapper">
                        <div className="calculator-slider-value">
                            {model.getCreditTerm()} {calc.l10n('CALCULATOR_MONTH')}
                        </div>

                        <div className="calculator-slider">
                            <input type="range"
                                name="loanTerm"
                                className="calculator-term-slider"
                                onChange={calc.handleChange}
                                value={model.getCurrentLoanTerm()}
                                min="0"
                                max={model.getTerms().length - 1}
                                step="1"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
}
